export default __webpack_public_path__ + "static/article-the-worlds-most-luxurious-cars-d11f03aa461b848027b2b161e2f4c23c.jpg";